import React, { ComponentType } from 'react';
import { components, InputProps } from 'react-select';

import { DepartureOption } from '@lt/api/dist/types/departure';

export const Input: ComponentType<InputProps<DepartureOption, false>> = (props) => (
  <components.Input data-lpignore="true" {...props} isHidden={false} />
);
